<template>
  <div>
    <v-dialog
      :value="value"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="1280"
      @input="$emit('input', $event)"
    >
      <v-card
        class="pa-4 ma-0"
        :class="{ glassmorphism: $vuetify.theme.dark }"
        :color="$vuetify.theme.dark ? 'transparent' : 'white'"
        elevation="0"
      >
        <TaskForm
          v-if="value && userInfo"
          :userInfo="userInfo"
          show-close
          show-cancel
          @created="onCreated"
          @cancel="closeDialog"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TaskForm from "@/components/modules/@tasks/TaskForm";

export default {
  name: "ComponentTaskAddDialog",
  props: {
    userInfo: {
      type: Object,
    },
    value: {
      type: Boolean,
    },
    refreshTasks: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    TaskForm,
  },
  methods: {
    closeDialog() {
      this.$emit("input", false);
    },
    onCreated() {
      this.$emit("input", false);
      if (this.refreshTasks) this.$emit("init");
    },
  },
};
</script>
